<template>
    <div class="modal order_modal_con fade" :class="{ in: isShowModal, active: isShow}"
        tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" v-show="isShow" id="guestPassport">
        <div class="modal-bg" @click="onModalClose"></div>
        <div class="common-modal-dialog modal-dialog" style="width: 715px;">
            <div class="modal-content passport_con">
                <div class="common-modal-close" data-dismiss="modal" aria-label="Close" @click="onModalClose">
                    <img src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/modal-close.jpg">
                </div>
                <div class="pspt_title">补全护照信息</div>
                <div class="msg_prompt">
                </div>
                <div class="pspt_name">{{(guest.chineseLastName+guest.chineseFirstName)}} {{(guest.pinYinLastName+ " " + guest.pinYinFirstName)}}</div>
                <div class="pspt_num_con">
                    <span>护照号</span>
                    <input type="text" placeholder="必填，必须与护照一致" v-model="passPortNum" data-key="PassPortNum" @focus="txtFocus" @input="passPortNumInput" name="" id="passportNumberInput">
                </div>
                <div class="pspt_num_con">
                    <span>有效期至</span>
                    <input type="text" placeholder="必填，必须与护照一致" v-model="passPortExpirationDate" data-key="PassPortExpirationDate" @focus="txtFocus" name="" id="passportDateInput"
                    @click.prevent="isCalendarShow=true">
                    <img src="https://resource.rcclchina.com.cn/tui2/order/calendar.png" class="calendar_icon" @click.prevent="isCalendarShow=true">
                    <RcclCalendar
                        class="guestInfo-calender"
                        v-if="isCalendarShow"
                        :allowPreYear="false"
                        :defaultDate="passPortExpirationDate"
                        v-on:onDateClicked="passPortExpirationDateChanged"
                    />
                </div>
                <div class="pspt_mark">一旦提交将不得更改，请再次确认。</div>

                <div class="btns_con">
                    <input type="button" class="close_guest_passport_modal" name="" value="取消" @click="onModalClose">
                    <input class="btn_sure submit-passport" type="button" name="" value="确定" @click="updateGuestPassport">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api'
const RcclCalendar = () => import('@/components/Common/RcclCalendar')
export default {
    name: "GuestPassportPopup",
    components: {
        RcclCalendar
    },
    props: {
        isShow: {
            type: Boolean
        },
        guest: {
            type: Object,
            default () {
                return {
                    chineseLastName: "",
                    chineseFirstName: "",
                    pinYinLastName: "",
                    pinYinFirstName: "",
                    id: 0,
                    passPortNum: "",
                    passPortExpirationDate: ""
                }
            }
        },
        onGuestPassportChange: {
            type: Function
        }
    },
    data () {
        return {
            isShowModal: false,
            passPortNum: "",
            passPortExpirationDate: "",
            isCalendarShow: false,
            originalPassPortNum: '',
            originalPassPortExpirationDate: '',
            isMaskValue: true,
            isPassPortExpirationDateChanged: false,
            updateFields: [],
            isPassPortNumInput: false
        }
    },
    mounted () {
        // this.passPortNum = this.guest.passPortNum
        // if (this.guest.passPortExpirationDate && this.guest.passPortExpirationDate.length > 0) {
        //     if (this.guest.passPortExpirationDate.length > 10) {
        //         this.passPortExpirationDate = this.guest.passPortExpirationDate.substring(0, 10)
        //     } else {
        //         this.passPortExpirationDate = this.guest.passPortExpirationDate
        //     }
        // }
    },
    methods: {
        onModalClose () {
          console.log('dd')
            this.isShowModal = false
            this.isCalendarShow = false
            this.updateFields = [];
            this.isPassPortNumInput = false;
            this.isPassPortExpirationDateChanged = false;
            this.passPortNum = this.originalPassPortNum = "";
            this.passPortExpirationDate = this.originalPassPortExpirationDate = "";
            setTimeout(()=> {
                this.$emit('onModalClose')
            }, 100)
        },
        passPortExpirationDateChanged(date) {
          this.isCalendarShow = false
          if(date) {
            this.passPortExpirationDate = date;
            this.isPassPortExpirationDateChanged = true;
            if(!this.updateFields.includes("PassPortExpirationDate")) {
              this.updateFields.push('PassPortExpirationDate');
            }
          }
        },
        async updateGuestPassport () {
            // if (!this.passPortNum || this.passPortNum.length == 0) {
            //     this.$alert.show("请填写护照号");
            //     return
            // }
            // if (!this.passPortExpirationDate || this.passPortExpirationDate.length == 0) {
            //     this.$alert.show("请填写护照有效期");
            //     return
            // }

            if (this.updateFields.length === 0) {
              this.$alert.show('没有任何修改');
              return false
            }

            if (!this.isMaskValue || this.updateFields.includes("PassPortNum")) {
              if (!this.passPortNum || this.passPortNum.length == 0) {
                this.$alert.show("请输入正确的护照号");
                return
              }
            }

            if (!this.isMaskValue || this.updateFields.includes("PassPortExpirationDate")) {
              if (!this.passPortExpirationDate || this.passPortExpirationDate.length == 0) {
                this.$alert.show("请填写护照有效期");
                return
              }
            }

            const request = {
                id: this.guest.id,
                passPortNum: this.passPortNum,
                passPortExpirationDate: this.passPortExpirationDate,
                updateFields: this.updateFields
            }
            this.$loading.show()
            const { success, errMsg } = await api.booking.updateBookingGuest(request)
            this.$loading.hide()
            if (!success) {
                if (errMsg && errMsg.length > 0) {
                    this.$alert.show(errMsg)
                }
            } else {
                this.$alert.show("修改成功")
                this.onModalClose();
                this.onGuestPassportChange(request)
            }
        },
        txtFocus(e) {
          let dataKey = e.target.getAttribute('data-key')
          if (this.isMaskValue) {
            if(dataKey === 'PassPortNum' && !this.isPassPortNumInput) {
              this.passPortNum = '';
              if(!this.updateFields.includes("PassPortNum")) {
                this.updateFields.push("PassPortNum")
              }
            }
            if(dataKey === 'PassPortExpirationDate' && !this.isPassPortExpirationDateChanged) {
              this.passPortExpirationDate = '';
              if(!this.updateFields.includes("PassPortExpirationDate")) {
                this.updateFields.push("PassPortExpirationDate")
              }
            }
          }
        },
        passPortNumInput() {
          this.isPassPortNumInput = true;
          if(!this.updateFields.includes("PassPortNum")) {
            this.updateFields.push("PassPortNum")
          }
        }
    },
    watch: {
        isShow (newValue) {
          setTimeout(()=> {
              this.isShowModal = newValue;
              this.isMaskValue = this.$store.state.page.isMaskValue;
              console.log(this.guest)
              if(newValue) {
                console.log(this.guest.passPortExpirationDateStr)
                console.log(this.guest.passPortExpirationDate)
                this.passPortNum = this.originalPassPortNum = this.guest.passPortNum
                let passPortExpirationDate = "";
                if (this.guest.passPortExpirationDate && this.guest.passPortExpirationDate.length > 0) {
                  if (this.guest.passPortExpirationDate.length > 10) {
                    passPortExpirationDate = this.originalPassPortExpirationDate = this.guest.passPortExpirationDate.substring(0, 10);
                    this.passPortExpirationDate = this.isMaskValue ? this.guest.passPortExpirationDateStr : passPortExpirationDate;
                  } else {
                    passPortExpirationDate = this.originalPassPortExpirationDate = this.guest.passPortExpirationDate;
                    this.passPortExpirationDate = this.isMaskValue ? this.guest.passPortExpirationDateStr : passPortExpirationDate;
                  }
                }
              }
          }, 100)
        },
        // guest (newValue) {
            // this.passPortNum = newValue.passPortNum
            // if (this.guest.passPortExpirationDate && newValue.passPortExpirationDate.length > 0) {
            //     if (this.guest.passPortExpirationDate.length > 10) {
            //         this.passPortExpirationDate = newValue.passPortExpirationDate.substring(0, 10)
            //     } else {
            //         this.passPortExpirationDate = newValue.passPortExpirationDate
            //     }
            // }
        // }
    }
}
</script>


<style lang="less" scoped>
.modal-body {
    padding: 20px;
    margin-top: 20px;
}
.modal-dialog {
    top: 50px;

}

.modal {
    .common-modal-close {
        position: absolute;
        width: 28px;
        top: 3px;
        right: 5px;
        z-index: 2;
        cursor: pointer;
    }
}

.modal.active {
    display: block;
}

.modal-bg {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
}


.order_modal_con {
    background-color: transparent;
}

.order_modal_con .common-modal-dialog {
    overflow: initial;
}

.order_modal_con .passport_con {
    background-color: #fff;
    border-radius: 5px;
}

.order_modal_con .passport_con .pspt_title {
    font-size: 18px;
    font-weight: 600;
    color: #282b2c;
    padding: 17px 22px;
}

.order_modal_con .passport_con .pspt_name {
    font-size: 14px;
    color: #282b2c;
    line-height: 18px;
    padding: 0 22px;
    margin-bottom: 17px;
}

.order_modal_con .passport_con .pspt_num_con {
    padding: 0 22px;
    font-size: 14px;
    color: #747d80;
    vertical-align: center;
    margin-bottom: 10px;
    position: relative;
    display: inline-block;
}

.order_modal_con .passport_con .pspt_num_con .calendar_icon {
    position: absolute;
    top: 8px;
    right: 30px;
}

.order_modal_con .passport_con .pspt_num_con input {
    height: 36px;
    width: 247px;
}

.order_modal_con .passport_con .pspt_mark {
    font-size: 12px;
    color: #ff3022;
    padding: 10px 22px;
    text-align: center;
}

.order_modal_con .passport_con .btns_con {
    padding: 10px 0;
    width: 100%;
    background-color: #f3f6f8;
    border-top: 1px solid #d3dadd;
    text-align: center;
}

.order_modal_con .passport_con .btns_con input {
    width: 78px;
    height: 30px;
    background-color: #ffffff;
    border: solid 1px #d3dadd;
}

.order_modal_con .passport_con .btns_con .btn_sure {
    background-color: #006ab9;
    color: #fff;
}

.order_modal_con .passport_con input {
    font-style: normal;
    padding-left: 5px;
    margin-left: 5px;
    border-top: none;
    border-left: none;
    border-right: none;
}
</style>
